<style lang="scss">


    .box{
        padding: 40px 10px;
        a{font-size:12px;text-decoration: underline;color:#5078e6;}

        .succBg{
            background: url("../../assets/images/recharge_succ.png") 0 0 no-repeat;
            background-size: 103px 78px;
        }
        .failBg{
            background: url("../../assets/images/recharge_fail.png") 0 0 no-repeat;
            background-size: 103px 78px;
        }
        .result-box{
            width:480px;
            height:100px;
            margin:100px 180px;
            padding-left:120px;

            h3.succ{
                font-size:24px;
                color:#48d2a0;
                font-weight: normal;
            }
            h3.fail{
                font-size:24px;
                color:#666666;
                font-weight: normal;


            }
            .info{
                font-size:16px;
                color:#666666;
                line-height:36px;
                margin-bottom: 30px;
                span{
                    color:#f68321;
                }
            }
        }



    }



</style>

<template>
    <div>
        <gf-page-title  title="账户充值" />
        <div class="box clearfix" v-loading="loading">
            <div class="result-box succBg" v-if="payData.status">
                <h3 class="succ">恭喜您，充值成功</h3>
                <p class="info">本次充值<span>{{payData.rechargeAmount | currency}}</span>元，当前账户余额<span>{{payData.userUnlockAmount | currency}}</span>元。</p>
                <el-button size="medium" type="primary" @click="goHome">返回首页</el-button>

            </div>
            <div class="result-box failBg" v-else>
                <h3 class="fail">很抱歉，充值失败。</h3>
                <p class="info">如果您有任何疑问，请致电400-811-2288</p>
                <el-button size="medium" type="primary" @click="goRecharge">重新充值</el-button>

            </div>
        </div>


    </div>
</template>
<script>
    import GfPageTitle from '../../components/gfPageTitle'
	export default {
		components:{GfPageTitle},

		data() {
		    return {
                loading:false,
				payData:{}


			}
        },
        methods:{
			getLocalData(){
				const payId = this.$route.params.payId
				const data = window.localStorage.getItem(payId)
                console.log('data',data)
				this.payData = Object.assign({},this.payData,JSON.parse(data))
                if(!this.payData.status){return}
				this.loading=true
				this.$axios({
					method: 'get',
					url: '/user/info'
				}).then( (res) =>{
					this.loading=false
					console.log(res)
                    this.$set(this.payData,'userUnlockAmount',res.data.rmbAmount)
					const baseInfo=Object.assign({},res.data)
					this.$store.commit('SET_USER',baseInfo)

				}).catch( (err) =>{
					console.warn(err)
					this.$alert('出错了，请稍后再试', '提示', {
						confirmButtonText: '确定',
					});
				})

            },
			goHome(){
				this.$router.push({name:'account'})
            },
			goRecharge(){
				this.$router.push({name:'recharge2'})
			}




        },
        created(){
			this.getLocalData()
        }
    }
</script>
